import Default from './default'
import createStore from 'redux-zero'

export default createStore(Default)
